import alt from '../alt';


class GlobalActions {
    constructor() {
        this.generateActions('saveDashboardTab', 'saveDashboardDate');
    }

}

export default alt.createActions(GlobalActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/GlobalActions.js
 **/